import styled from 'styled-components'
import { device } from '../../../styles/GlobalVariables'

export const AdBlockSlideWrap = styled.div`
  position: relative;
  aspect-ratio: 9/16;
  width: 100%;
  height: calc(100dvh - env(safe-area-inset-bottom));
  overflow: hidden;

  ${device.medium} {
    width: auto;
    height: 80vh;
    border-radius: 0px;
  }
`

export const AdBlockImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: inherit;
`
